<div class="content right" ngDraggable [handle]="DragHandle" style="z-index: 999;">
    <!-- Close icon -->
    <div class="draggableArea" #DragHandle>
      <i class="fa fa-bars menu"></i>
      <span class="title">Drag & Drop Document using this header</span>
      <div class="closePreview" (click)="expandArea()" style="right: 35px;">
        <i class="fa fa-expand expand"></i>
      </div>
      <div class="closePreview" (click)="closePreview()">
        <i class="fa fa-close"></i>
      </div>
    </div>

    <div class="content-wrapper" [ngClass]="{'medium': size === PreviewSize.MEDIUM,
                  'large': size === PreviewSize.LARGE}">
       <div class="modal-header">
        <h4 class="modal-title pull-left mt-2">Initial Email (No Engagement Letter)</h4>
        <div class="reset mt-2" (click)="resetTemplate()">Reset to Initial Template</div>
      </div>

      <div class="modal-body">
        <div class="recipients">
          <div class="row">
            <div class="col-md-12">
              <label class="rbv-label">Recipient to:</label>
              <input-search #recipientField [preset]="userTypes" [provider]="userProvider" placeholder="Select Recipient"
                            [presetHeader]="'Client User'" (multipleValueChanged)="recipientChanged($event)"
                            [multiple]="true" [typeEmail]="true" [refresh]="true" [parent-id]="currentReport.CLIENT?.ID"></input-search>
            </div>
          </div>

          <div class="row" style="margin-top: 5px;">
            <div class="col-md-12">
              <label class="rbv-label">CC:</label>
              <input-search #ccField [preset]="userTypes" [provider]="userProvider" placeholder="Select CC Recipients"
                            [presetHeader]="'Client Users'" [multiple]="true" [typeEmail]="true"
                            (multipleValueChanged)="ccChanged($event)"
                            [parent-id]="currentReport.CLIENT?.ID"></input-search>
            </div>
            <div class="col-md-12 mt-2">
              <label class="rbv-label">BCC:</label>
              <input-search #bccField [preset]="userTypes" [provider]="userProvider" placeholder="Select BCC Recipients"
                            [presetHeader]="'Client Users'" [multiple]="true" [typeEmail]="true"
                            (multipleValueChanged)="bccChanged($event)"
                            [parent-id]="currentReport.CLIENT?.ID"></input-search>
            </div>
          </div>
        </div>

        <div class="subject mt-2">
          <label class="rbv-label">Subject:</label>
          <input type="text" name="mailSubject" class="form-control rounded-0" [(ngModel)]="htmlSubject">
        </div>

        <!-- <angular-editor [(ngModel)]="htmlContent" [config]="editorConfig"></angular-editor> -->
        <quill-editor [styles]="editorStyle" [(ngModel)]="htmlContent" (onContentChanged)="onContentChanged($event)" (onEditorChanged)="onEditorChanged($event)" (onEditorCreated)="created($event)" [modules]="quillModules"></quill-editor>

        <div class="row mt-3">
          <div class="col-md-6">
            <label class="rbv-label">Attachments</label>
            <app-file-picker (fileChanged)="onFileChanged($event)"></app-file-picker>
          </div>


          <div class="col-md-6">
            <label class="rbv-label">Canned Response</label>
            <input-search [provider]="cannedResponseProvider" (valueChange)="onCannedValueChange($event)"></input-search>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div class="footer-wrapper">
          <div class="warnings">
            <div class="text-wrapper" *ngIf="!user.SIGNATURE">
              <fa name="fa fa-exclamation-triangle" style="color: orange; margin-left: 5px;"></fa>
              <span class="warning-text"> Current User has no Signature. Edit Signature in <a (click)="gotoProfile()"
                  href="javaScript:void(0);">Profile</a></span>
            </div>
          </div>

          <div class="actions">
            <button class="btn btn-rbv default" (click)="closePreview()" [disabled]="isLoading || isLoadingPreview">Cancel</button>
            <button class="btn btn-rbv" (click)="onConfirm()" *ngIf="!isLoading" [disabled]="isLoadingPreview">Send</button>
            <button class="btn btn-rbv" disabled *ngIf="isLoading">
              <span class="loading-icon-small"></span> Sending
            </button>
          </div>
        </div>
      </div>
    </div>
</div>
